import * as types from "./types";

const defaultState = {

    calendarList: [],
    calendar: [],
    calendarTable: {

        tableHeaders: [
            "Title",
            "Date",
            "Time",
            "Status",
            "Officer",
            "Actions"
        ],
        tableColumns: [
            "calendarTitle",
            "calendarDate",
            "calendarTime",
            "calendarStatus",
            "calendarIsOfficer"
        ]
    },
    calendarForm: {
        model: "CalendarModel",
        form: [
            {
                type: 'text',
                label: 'Title',
                name: 'calendarTitle',
                placeholder: 'Enter title',
                default: '',
                required: true,
                md: 6,
                xs: 12,
                maxLength: 125
            },
            {
                type: 'dateTimeRange',
                required: true,
                default: '',
                maxLength: 255,
                md: 12,
                xs: 12
            },
            {
                type: "checkbox",
                label: "Officers only",
                name: "isOfficer",
                default: false,
                md: 2,
                xs: 12
            },
        ]
    },

};

export default function reducer(state = defaultState, action) {
    switch (action.type) {

        case types.SET_LIST:
            return { ...state, calendarList: action.payload };
        case types.SET_CALENDAR:
            return { ...state, calendar: action.payload }
        default: return state;
    }
}